import { connect } from "react-redux";

import { getCityById } from "domain/Directories/selectors";
import Component from "./Component";
import { getWidth } from "domain/Version/selectors";
import { getUserById } from "domain/Users/selectors";
import {isLoggedIn} from "domain/Auth/selectors";

const mapStateToProps = (state, { playerId }) => {
    const profile = getUserById(state, playerId);
    const cityName = getCityById(state, profile?.city_id)?.name;

    return {
        profile,
        cityName,
        minWidth: getWidth(state),
        isLoggedIn: isLoggedIn(state)
    };
};
export default connect(mapStateToProps)(Component);
